import { Component, Input } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-icon-component',
  templateUrl: './icon-component.component.html',
  styleUrls: ['./icon-component.component.scss']
})
export class IconComponentComponent {
  @Input() component: any;

  constructor(
    public statesService: StatesService,
    public contentService: ContentService
  ) {}
  ngOnInit(): void {}

  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
}
